"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZERO_PRICE = exports.ENVIRONMENT_URL = exports.ENVIRONMENT = exports.DEFAULT_ENV = exports.BPC_CONSTANTS = void 0;
var ENVIRONMENT = ['DEVELOPMENT', 'STAGING', 'PRE_PRODUCTION', 'PRODUCTION'];
exports.ENVIRONMENT = ENVIRONMENT;
var BPC_CONSTANTS = {
  baseFareName: 'Base Fare',
  baseFareType: 'base_fare',
  taxName: 'Goods and service tax',
  taxType: 'service_tax',
  paymentStatus: 'payment_successful',
  paymentMethod: 'CREDIT_CARD',
  constantId: '123',
  orderId: 123,
  status: 'completed',
  orderType: 'FlightOTA',
  memberTier: 'T1',
  firstName: 'Jane',
  lastName: 'Doe',
  title: 'Ms',
  email: 'jane@doe.com',
  culture: 'en-gb',
  date: '2021-07-07 01:23:55.0'
};
exports.BPC_CONSTANTS = BPC_CONSTANTS;
var ZERO_PRICE = 0;
exports.ZERO_PRICE = ZERO_PRICE;
var DEFAULT_ENV = 'STAGING';
exports.DEFAULT_ENV = DEFAULT_ENV;
var ENVIRONMENT_URL = {
  DEVELOPMENT: {
    BPC_URL: 'https://oms.devairasia.com/bpCalculator/api/v1/bigpoint/calculation'
  },
  STAGING: {
    BPC_URL: 'https://oms.stgairasia.com/bpCalculator/api/v1/bigpoint/calculation'
  },
  PRE_PRODUCTION: {
    BPC_URL: 'https://oms.stgairasia.com/bpCalculator/api/v1/bigpoint/calculation'
  },
  PRODUCTION: {
    BPC_URL: 'https://oms.airasia.com/bpCalculator/api/v1/bigpoint/calculation'
  }
};
exports.ENVIRONMENT_URL = ENVIRONMENT_URL;